<app-maintenance-mode-alert></app-maintenance-mode-alert>
<app-location-context-panel></app-location-context-panel>

<!-- Content -->
<div class="content" *ngIf="dockingContext">
    <app-docking-info [dockingContext]="dockingContext"></app-docking-info>
    <app-docking-commands [dockingContext]="dockingContext"></app-docking-commands>
    <app-docking-camera [dockingContext]="dockingContext"></app-docking-camera>
</div>
